import { plural } from '@cian/utils';
export var getDescription = function getDescription(count) {
  return count ? "".concat(count, " ").concat(plural(count, ['объявление', 'объявления', 'объявлений'])) : 'Нет объявлений';
};